import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-md" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = ["onDblclick"]
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_editable_block_iban_input = _resolveComponent("editable-block-iban-input")!
  const _component_editable_block = _resolveComponent("editable-block")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_editable_block, {
        "model-value": _ctx.businessRegistrationDetails,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:business-registration-details', { ..._ctx.tenant, settings: { company: $event }}))),
        title: "Business registration details",
        layout: "grid"
      }, {
        default: _withCtx(({editState, editingRef}) => [
          _createElementVNode("div", {
            class: "business-registration-details",
            onDblclick: ($event: any) => (editingRef.value = true)
          }, [
            (!editingRef.value)
              ? (_openBlock(), _createBlock(_component_tooltip, {
                  key: 0,
                  selector: ".business-registration-details",
                  "tooltip-value": "Double click to edit"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_editable_block_input, {
                "model-value": editState.financial?.bank_name,
                "onUpdate:modelValue": ($event: any) => (editState.financial.bank_name = $event),
                label: "Bank name"
              }, null, 8, ["model-value", "onUpdate:modelValue"]),
              _createVNode(_component_editable_block_input, {
                "model-value": editState.financial?.bic,
                "onUpdate:modelValue": ($event: any) => (editState.financial.bic = $event),
                label: "BIC / SWIFT code",
                tooltip: "Most banks include their BIC / SWIFT code in customer account details. It is often in the same place as your IBAN number."
              }, null, 8, ["model-value", "onUpdate:modelValue"]),
              _createVNode(_component_editable_block_iban_input, {
                editing: editingRef.value,
                "model-value": editState.financial?.iban,
                "onUpdate:modelValue": ($event: any) => (editState.financial.iban = $event),
                label: "IBAN number"
              }, null, 8, ["editing", "model-value", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_editable_block_input, {
                "model-value": editState.tax?.id,
                "onUpdate:modelValue": ($event: any) => (editState.tax.id = $event),
                label: "VAT ID number"
              }, null, 8, ["model-value", "onUpdate:modelValue"]),
              _createVNode(_component_editable_block_input, {
                "model-value": editState.tax?.registrar,
                "onUpdate:modelValue": ($event: any) => (editState.tax.registrar = $event),
                label: "Tax authority",
                tooltip: "What is the name of the tax authority in the country your company is based?"
              }, null, 8, ["model-value", "onUpdate:modelValue"]),
              _createVNode(_component_editable_block_input, {
                "model-value": editState.registration?.id,
                "onUpdate:modelValue": ($event: any) => (editState.registration.id = $event),
                label: "Chamber of Commerce ID"
              }, null, 8, ["model-value", "onUpdate:modelValue"]),
              _createVNode(_component_editable_block_input, {
                "model-value": editState.registration?.registrar,
                "onUpdate:modelValue": ($event: any) => (editState.registration.registrar = $event),
                label: "Chamber of Commerce",
                tooltip: "What is the name of the Chamber of Commerce in the country your company is based?"
              }, null, 8, ["model-value", "onUpdate:modelValue"])
            ])
          ], 40, _hoisted_3)
        ]),
        _: 1
      }, 8, ["model-value"])
    ])
  ]))
}